// extracted by mini-css-extract-plugin
export default {"wrapper":"RA-z","button":"SA-z","alternate":"TA-z","disabled":"UA-z","paymentWarning":"VA-z","fadeIn":"WA-z"};